import { render, staticRenderFns } from "./record.vue?vue&type=template&id=d1e2abea&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style1 from "./record.vue?vue&type=style&index=1&id=d1e2abea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e2abea",
  null
  
)

export default component.exports